import React from 'react';
import { Modal } from 'antd';
import '../../../index.scss';

const CreateNewCount = ({ showModal, hideModal, newDayCount, setNewDayCount, className, handleCreateNew }) => {
  return (
    <Modal
      className={className}
      centered
      visible={showModal}
      onCancel={() => hideModal(false)}
      width={400}
      footer={null}
      title="Enter Number of Transactions"
    >
      <div className='col-md-12 mt-4'>
        <label className='form-label'>Number of Transactions</label>
        <input
          type='number'
          className='form-control'
          value={newDayCount}
          required
          onChange={(e) => setNewDayCount(e.target.value)}
          placeholder="e.g. 5"
        />
      </div>

      <div className='col-12 text-end mt-5'>
        <button className='btn btn-primary' type='button' onClick={handleCreateNew}>
          Save
        </button>
      </div>
    </Modal>
  );
};

export default CreateNewCount;
